export default __webpack_public_path__ + "static/innovaid-1c27ca1c40741e57c0fb2113022e9c9f.png";